interface CtaBannerProps {
  variant?: 'primary' | 'secondary';
  headline: string;
  subheadline?: string;
  buttonText: string;
  buttonUrl: string;
  showProductStrip?: boolean;
}

export default function CtaBanner({
  variant = 'primary',
  headline,
  subheadline,
  buttonText,
  buttonUrl,
  showProductStrip = false,
}: CtaBannerProps) {
  const bgClass = variant === 'primary'
    ? 'bg-background-50'
    : 'bg-background-100';

  return (
    <section className={`py-14 md:py-18 ${bgClass}`}>
      <div className="px-4 md:px-6 max-w-7xl mx-auto text-center">
        <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 leading-tight max-w-2xl mx-auto">
          {headline}
        </h2>
        {subheadline && (
          <p className="text-sm md:text-base text-foreground-600 mt-3 md:mt-4 max-w-lg mx-auto">
            {subheadline}
          </p>
        )}
        <a
          href={buttonUrl}
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-full text-sm md:text-base font-medium hover:bg-primary-600 transition-colors mt-6 md:mt-8 whitespace-nowrap"
        >
          {buttonText}
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line text-sm"></i>
          </span>
        </a>
      </div>

      {/* Product strip */}
      {showProductStrip && (
        <div className="mt-10 md:mt-14 overflow-hidden">
          <div className="flex gap-3 md:gap-4 px-4">
            {[
              'https://readdy.ai/api/search-image?query=Minimalist%20fashion%20sneaker%20on%20clean%20cream%20background%2C%20product%20photography%2C%20soft%20natural%20lighting%2C%20isolated%20studio%20shot%2C%20warm%20neutral%20aesthetic%2C%20professional%20catalog%20style&width=400&height=400&seq=strip-prod-01&orientation=squarish',
              'https://readdy.ai/api/search-image?query=Elegant%20leather%20handbag%20on%20clean%20cream%20background%2C%20minimalist%20product%20photography%2C%20soft%20natural%20lighting%2C%20studio%20shot%2C%20warm%20neutral%20aesthetic%2C%20professional%20catalog%20style&width=400&height=400&seq=strip-prod-02&orientation=squarish',
              'https://readdy.ai/api/search-image?query=Stylish%20watch%20accessory%20on%20clean%20cream%20background%2C%20minimalist%20product%20photography%2C%20soft%20natural%20lighting%2C%20studio%20shot%2C%20warm%20neutral%20aesthetic%2C%20professional%20catalog%20style&width=400&height=400&seq=strip-prod-03&orientation=squarish',
              'https://readdy.ai/api/search-image?query=Modern%20sunglasses%20on%20clean%20cream%20background%2C%20minimalist%20product%20photography%2C%20soft%20natural%20lighting%2C%20studio%20shot%2C%20warm%20neutral%20aesthetic%2C%20professional%20catalog%20style&width=400&height=400&seq=strip-prod-04&orientation=squarish',
              'https://readdy.ai/api/search-image?query=Premium%20perfume%20bottle%20on%20clean%20cream%20background%2C%20minimalist%20product%20photography%2C%20soft%20natural%20lighting%2C%20studio%20shot%2C%20warm%20neutral%20aesthetic%2C%20professional%20catalog%20style&width=400&height=400&seq=strip-prod-05&orientation=squarish',
            ].map((src, i) => (
              <div key={i} className="flex-shrink-0 w-24 h-24 md:w-32 md:h-32 rounded-xl overflow-hidden">
                <img
                  src={src}
                  alt="Featured product from itaobuy spreadsheet catalog"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </section>
  );
}